import { IntlProvider } from "react-intl";
import { defaultLocale, locales } from "./i18n-config";
import { useEffect, useState } from "react";
import { LocaleContext } from "./LocaleContext";
import { useSelector } from "react-redux";
import { selectCurrent } from "../redux/settings/selectors";

export default function I18n(props) {
	const result = useSelector(selectCurrent)
	const { language } = result
	const [locale, setLocale] = useState(defaultLocale);

	useEffect(() => {
		setLocale(language)
	}, [language])
	return (
		<LocaleContext.Provider value={{ locale, setLocale }}>
			<IntlProvider
				locale={locale}
				defaultLocale={defaultLocale}
				messages={locales[locale].messages}
			>
				{props.children}
			</IntlProvider>
		</LocaleContext.Provider>
	);
}